<mat-form-field [class.bordered]="bordered" [class.disabled]="disabled">
    @if (label) {
        <mat-label>{{ label }}</mat-label>
    }
    <textarea
        [attr.data-uiid]="textareaUiid"
        class="regular-text"
        matInput
        [formControl]="formController"
        (keyup)="onModelChanged()"
    ></textarea>
</mat-form-field>
